import { render, staticRenderFns } from "./case-card.html?vue&type=template&id=3ecb59e7&scoped=true&"
import script from "./case-card.js?vue&type=script&lang=js&"
export * from "./case-card.js?vue&type=script&lang=js&"
import style0 from "./case-card.scss?vue&type=style&index=0&id=3ecb59e7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecb59e7",
  null
  
)

export default component.exports